/** WebGL2 falls back to CPU splat sorting; cap budget so non-WebGPU browsers stay interactive. */
export const WEBGL2_SPLAT_BUDGET = 2_500_000;
/**
 * Touch WebGL2 cap. The mobile asset has a ~155K coarsest level, so this budget can be spent
 * refining nearby octree nodes instead of being exceeded by the baseline before refinement starts.
 */
export const WEBGL2_TOUCH_SPLAT_BUDGET = 1_500_000;

export function capSplatBudgetForGraphics(
  splatBudget: number,
  options: { isWebGPU: boolean; isTouchMode: boolean; touchBudget?: number },
): number {
  if (options.isWebGPU) return splatBudget;
  const touchBudget =
    options.touchBudget != null && Number.isFinite(options.touchBudget) && options.touchBudget > 0
      ? Math.min(options.touchBudget, WEBGL2_TOUCH_SPLAT_BUDGET)
      : WEBGL2_TOUCH_SPLAT_BUDGET;
  return Math.min(
    splatBudget,
    options.isTouchMode ? touchBudget : WEBGL2_SPLAT_BUDGET,
  );
}
